import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerButtonsInlineStyles = /*#__PURE__*/function () {
  function BlockerButtonsInlineStyles() {
    _classCallCheck(this, BlockerButtonsInlineStyles);
  }

  _createClass(BlockerButtonsInlineStyles, null, [{
    key: "save",
    value: function save(_ref, isHover, framed) {
      var acceptAll = _ref.decision.acceptAll,
          borderRadius = _ref.layout.borderRadius,
          linkTextDecoration = _ref.design.linkTextDecoration,
          _ref$bodyDesign = _ref.bodyDesign,
          acceptAllFontSize = _ref$bodyDesign.acceptAllFontSize,
          acceptAllBg = _ref$bodyDesign.acceptAllBg,
          acceptAllTextAlign = _ref$bodyDesign.acceptAllTextAlign,
          acceptAllBorderColor = _ref$bodyDesign.acceptAllBorderColor,
          acceptAllPadding = _ref$bodyDesign.acceptAllPadding,
          acceptAllBorderWidth = _ref$bodyDesign.acceptAllBorderWidth,
          acceptAllFontColor = _ref$bodyDesign.acceptAllFontColor,
          acceptAllHoverBg = _ref$bodyDesign.acceptAllHoverBg,
          acceptAllHoverFontColor = _ref$bodyDesign.acceptAllHoverFontColor,
          acceptAllHoverBorderColor = _ref$bodyDesign.acceptAllHoverBorderColor,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return this.common({
        name: "accept-all",
        type: acceptAll,
        borderRadius: borderRadius,
        bg: acceptAllBg,
        hoverBg: acceptAllHoverBg,
        fontSize: acceptAllFontSize,
        textAlign: acceptAllTextAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: acceptAllFontColor,
        hoverFontColor: acceptAllHoverFontColor,
        borderWidth: acceptAllBorderWidth,
        borderColor: acceptAllBorderColor,
        hoverBorderColor: acceptAllHoverBorderColor,
        padding: acceptAllPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "showInfo",
    value: function showInfo(_ref2, isHover, framed) {
      var acceptIndividual = _ref2.decision.acceptIndividual,
          borderRadius = _ref2.layout.borderRadius,
          linkTextDecoration = _ref2.design.linkTextDecoration,
          _ref2$bodyDesign = _ref2.bodyDesign,
          acceptIndividualFontSize = _ref2$bodyDesign.acceptIndividualFontSize,
          acceptIndividualBg = _ref2$bodyDesign.acceptIndividualBg,
          acceptIndividualTextAlign = _ref2$bodyDesign.acceptIndividualTextAlign,
          acceptIndividualBorderColor = _ref2$bodyDesign.acceptIndividualBorderColor,
          acceptIndividualPadding = _ref2$bodyDesign.acceptIndividualPadding,
          acceptIndividualBorderWidth = _ref2$bodyDesign.acceptIndividualBorderWidth,
          acceptIndividualFontColor = _ref2$bodyDesign.acceptIndividualFontColor,
          acceptIndividualHoverBg = _ref2$bodyDesign.acceptIndividualHoverBg,
          acceptIndividualHoverFontColor = _ref2$bodyDesign.acceptIndividualHoverFontColor,
          acceptIndividualHoverBorderColor = _ref2$bodyDesign.acceptIndividualHoverBorderColor,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      return this.common({
        name: "accept-individual",
        type: acceptIndividual,
        borderRadius: borderRadius,
        bg: acceptIndividualBg,
        hoverBg: acceptIndividualHoverBg,
        fontSize: acceptIndividualFontSize,
        textAlign: acceptIndividualTextAlign,
        linkTextDecoration: linkTextDecoration,
        fontColor: acceptIndividualFontColor,
        hoverFontColor: acceptIndividualHoverFontColor,
        borderWidth: acceptIndividualBorderWidth,
        borderColor: acceptIndividualBorderColor,
        hoverBorderColor: acceptIndividualHoverBorderColor,
        padding: acceptIndividualPadding,
        antiAdBlocker: antiAdBlocker
      }, isHover, framed);
    }
  }, {
    key: "common",
    value: function common(_ref3, isHover, framed) {
      var name = _ref3.name,
          type = _ref3.type,
          borderRadius = _ref3.borderRadius,
          bg = _ref3.bg,
          hoverBg = _ref3.hoverBg,
          fontSize = _ref3.fontSize,
          textAlign = _ref3.textAlign,
          linkTextDecoration = _ref3.linkTextDecoration,
          fontColor = _ref3.fontColor,
          hoverFontColor = _ref3.hoverFontColor,
          borderWidth = _ref3.borderWidth,
          borderColor = _ref3.borderColor,
          hoverBorderColor = _ref3.hoverBorderColor,
          padding = _ref3.padding,
          antiAdBlocker = _ref3.antiAdBlocker;
      var style = {
        textDecoration: type === "link" ? linkTextDecoration : "none",
        borderRadius: +borderRadius,
        cursor: type === "button" ? "pointer" : undefined,
        backgroundColor: type === "button" ? isHover ? hoverBg : bg : undefined,
        fontSize: +fontSize,
        textAlign: textAlign,
        color: isHover ? hoverFontColor : fontColor,
        transition: "background-color 250ms, color 250ms, border-color 250ms",
        marginBottom: 10,
        border: type === "button" && borderWidth > 0 ? "".concat(borderWidth, "px solid ").concat(isHover ? hoverBorderColor : borderColor) : undefined,
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        overflow: "hidden",
        outline: framed ? "rgb(255, 94, 94) solid 5px" : undefined
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-btn-".concat(name),
        style: style
      };
    }
  }]);

  return BlockerButtonsInlineStyles;
}();

export { BlockerButtonsInlineStyles };